import { combineReducers } from 'redux';
import * as actionTypes from '../action-mgr/actionTypes';

const portfolioFaultTotalize = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.GET_PORTFOLIO_FAULT_TOTALIZE_DATA:
            return { ...state, ...action.payload }; // Ensure new data is spread correctly
        default:
            return state;
    }
};

const portfolioFaultDetails = (state = { 
    userRole: "", 
    companyList: [], 
    countryList: [],
    cityList: [],
    projectList: [], 
    yearList: [], 
    stationDetails: [], 
    stationsTotal: 0,   
    loading: false, 
    error: null 
  }, action) => {
    switch (action.type) {
      case actionTypes.GET_PORTFOLIO_FAULT_DETAILS_REQUEST:
        return { ...state, loading: true, error: null };

      case actionTypes.GET_PORTFOLIO_FAULT_DETAILS_SUCCESS:
        return { 
          ...state, 
          loading: false, 
          error: null,
          userRole: action.data.userRole || "", 
          companyList: action.data.companyList || [], 
          countryList: action.data.countryList || [],
          cityList: action.data.cityList || [],
          projectList: action.data.projectList || [], 
          yearList: action.data.yearList || [], 
          stationDetails: action.data.stationDetails || [], 
          stationsTotal: action.data.stationsTotal || 0,   
        };

      case actionTypes.GET_PORTFOLIO_FAULT_DETAILS_FAILURE:
        return { 
          ...state, 
          loading: false, 
          error: action.error, 
          userRole: "", 
          companyList: [], 
          countryList: [],
          cityList: [],
          projectList: [], 
          yearList: [], 
          stationDetails: [], 
          stationsTotal: 0,
        };

      case actionTypes.RESET_PORTFOLIO_FAULT_DETAILS_FILTER:
        return { 
          userRole: "", 
          companyList: [], 
          countryList: [],
          cityList: [],
          projectList: [], 
          yearList: [], 
          stationDetails: [],
          stationsTotal: 0,
          loading: false, 
          error: null 
        };

      case actionTypes.UPDATE_PORTFOLIO_FAULT_DETAILS_FILTER:
        return {
          ...state,
          ...action.payload // Merge the updated values from action.payload
        };

      default:
        return state;
    }
};

const selectedPortfolioFaultCompany = (state = "", action) => {
    switch (action.type) {
      case actionTypes.GET_PORTFOLIO_FAULT_TOTALIZE_DATA:
        return action.payload.companyName || state; // Set from companyName inside portfolioTotalize
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_COMPANY:
        return action.selectedPortfolioFaultCompany || state; 
      default:
        return state;
    }
};

const selectedPortfolioFaultCountry = (state = "", action) => {
    switch (action.type) {
      case actionTypes.RESET_PORTFOLIO_FAULT_COUNTRY:
        return ""; // Clear the selected COUNTRY
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_COUNTRY: 
        return action.selectedPortfolioFaultCountry;
      default:
        return state;
    }
};

const selectedPortfolioFaultCity = (state = "", action) => {
    switch (action.type) {
      case actionTypes.RESET_PORTFOLIO_FAULT_CITY:
        return ""; // Clear the selected CITY
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_CITY: 
        return action.selectedPortfolioFaultCity;
      default:
        return state;
    }
};

const selectedPortfolioFaultProject = (state = "", action) => {
    switch (action.type) {
      case actionTypes.RESET_PORTFOLIO_FAULT_PROJECT:
        return ""; // Clear the selected PROJECT
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_PROJECT: 
        return action.selectedPortfolioFaultProject;
      default:
        return state;
    }
};

const selectedPortfolioFaultStations = (state = [], action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_STATIONS:
        return action.selectedPortfolioFaultStation; // Assuming the payload is an array
      case actionTypes.UPDATE_SELECTED_PORTFOLIO_FAULT_STATIONS:
        return [...state, ...action.payload]; // Merge new stations with existing ones
      case actionTypes.RESET_SELECTED_PORTFOLIO_FAULT_STATIONS:
        return []; // Reset to an empty array
      default:
        return state;
    }
};

const portfolioFaultLevels = (state = [], action) => {
    switch (action.type) {
      case actionTypes.FETCH_PORTFOLIO_FAULT_LEVELS_SUCCESS:
        return action.payload;
      case actionTypes.FETCH_PORTFOLIO_FAULT_LEVELS_FAILURE:
        return []; // Reset to an empty array on failure
      default:
        return state;
    }
};

const selectedPortfolioFaultLevel = (state = "country", action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_LEVEL:
        return action.selectedPortfolioFaultLevel || state;
      case actionTypes.RESET_SELECTED_PORTFOLIO_FAULT_LEVEL:
        return "country"; // Default reset to 'country'
      case actionTypes.FETCH_PORTFOLIO_FAULT_LEVELS_SUCCESS:
        const defaultLevel = action.payload.find(level => level.portfolioSelection.toLowerCase() === 'country');
        return defaultLevel ? defaultLevel.portfolioSelection : state; 
      default:
        return state;
    }
};

const selectedPortfolioFaultDisplayMode = (state = "year", action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_DISPLAY_MODE:
        return action.selectedPortfolioFaultDisplayMode;
      default:
        return state;
    }
};

const selectedPortfolioFaultYear = (state = "", action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_YEAR:
        return action.selectedPortfolioFaultYear;
      default:
        return state;
    }
};

const selectedPortfolioFaultMonth = (state = "", action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_MONTH:
        return action.selectedPortfolioFaultMonth;
      default:
        return state;
    }
};

const selectedPortfolioFaultDay = (state = "", action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_PORTFOLIO_FAULT_DAY:
        return action.selectedPortfolioFaultDay;
      default:
        return state;
    }
};

export const portfolioFaultQueryData = (state = {
  portfolioFaultData: [],
  loading: false,
  error: null,
}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PORTFOLIO_FAULT_REQUEST:
      return { ...state, loading: true, error: null };

    case actionTypes.FETCH_PORTFOLIO_FAULT_SUCCESS:
      return {
        ...state,
        portfolioFaultData: action.portfolioFaultData || [],
        loading: false, 
      };

    case actionTypes.FETCH_PORTFOLIO_FAULT_FAILURE:
      return { ...state, loading: false, error: action.message };

    case actionTypes.RESET_PORTFOLIO_FAULT_DATA:
      return {
        portfolioFaultData:  [],
        loading: false,
        error: null,
      };
  
    // portfolioFaultLogData reducer
    case actionTypes.RESET_PORTFOLIO_FAULT_LOG:
      return [];

    default:
      return state;
  }
};

const portfolioFaultLogData = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_PORTFOLIO_FAULT_LOG_SUCCESS:
      return action.portfolioFaultLog || []; // ensure it's always an array

    case actionTypes.RESET_PORTFOLIO_FAULT_LOG:
      return []; // clear log data when resetting

    default:
      return state;
  }
};

export default combineReducers({
    portfolioFaultTotalize,
    portfolioFaultDetails,
    portfolioFaultQueryData,
    portfolioFaultLogData,
    selectedPortfolioFaultCompany,
    selectedPortfolioFaultCountry,
    selectedPortfolioFaultCity,
    selectedPortfolioFaultProject,
    selectedPortfolioFaultStations,
    portfolioFaultLevels,
    selectedPortfolioFaultLevel,
    selectedPortfolioFaultDisplayMode,
    selectedPortfolioFaultYear,
    selectedPortfolioFaultMonth,
    selectedPortfolioFaultDay
});

const getCurrentState = state => state.portfolioFaultOverview;
export const getPortfolioFaultTotalize = state => getCurrentState(state).portfolioFaultTotalize;
export const getPortfolioFaultDetails = state => getCurrentState(state).portfolioFaultDetails;
export const getPortfolioFaultData = state => getCurrentState(state).portfolioFaultQueryData;
export const getPortfolioFaultLogData = state => getCurrentState(state).portfolioFaultLogData;
export const getSelectedPortfolioFaultCompany = state => getCurrentState(state).selectedPortfolioFaultCompany;   
export const getSelectedPortfolioFaultCountry = state => getCurrentState(state).selectedPortfolioFaultCountry;
export const getSelectedPortfolioFaultCity = state => getCurrentState(state).selectedPortfolioFaultCity;
export const getSelectedPortfolioFaultProject = state => getCurrentState(state).selectedPortfolioFaultProject;
export const getSelectedPortfolioFaultStations = state => getCurrentState(state).selectedPortfolioFaultStations;

export const getPortfolioFaultLevels = state => getCurrentState(state).portfolioFaultLevels;
export const getSelectedPortfolioFaultLevel = state => getCurrentState(state).selectedPortfolioFaultLevel;

export const getSelectedPortfolioFaultDisplayMode = state => getCurrentState(state).selectedPortfolioFaultDisplayMode;

export const getSelectedPortfolioFaultYear = state => getCurrentState(state).selectedPortfolioFaultYear;
export const getSelectedPortfolioFaultMonth = state => getCurrentState(state).selectedPortfolioFaultMonth;
export const getSelectedPortfolioFaultDay = state => getCurrentState(state).selectedPortfolioFaultDay;

